import React from 'react';
import { observer, inject } from 'mobx-react';

const PartialStatus = ({ id, document_store }) => {
    const document = document_store.documents[id];

    const partial = document.partial || {done: 0, total: 0, percent: 100};
    const percent = partial.percent || 0;

    let classColor = 'c-green';

    if(percent <= 24) {
        classColor = 'c-red';
    } else if (percent > 24 && percent <= 50) {
        classColor = 'c-orange';
    } else if (percent > 50 && percent < 95) {
        classColor = 'c-orange';
    }

    return (<span title={'Notas entregues'} data-last-sync-at={document_store.updated_at} className={`${classColor}`}>{partial.done} / {partial.total} ({Math.round(partial.percent) || '0'}%)</span>);
}

PartialStatus.defaultProps = {
    id: null
};

let container = observer(PartialStatus);
container = inject(['document_store'])(container);

export default container;



// WEBPACK FOOTER //
// ./src/components/Status/Partial.js